import { createEvent, createStore } from 'effector'

export const actions = {
  setPlans: createEvent<Plan[]>('setPlans'),
  resetPlans: createEvent('resetPlans'),
  updatePlan: createEvent<Plan>('updatePlan'),

  reset: createEvent('reset'),
}

const initialState: PlanState = {
  plans: [],
}

export const store = createStore<PlanState>(initialState, { name: 'plan' })
  .on(actions.setPlans, (s, plans) => ({ ...s, plans }))
  .on(actions.resetPlans, (s) => ({ ...s, plans: initialState.plans }))
  .on(actions.updatePlan, (s, plan) => ({
    ...s,
    plans: [...s.plans.filter((p) => p.localisationId !== plan.localisationId), plan],
  }))
  .reset(actions.reset)
